module.exports = __webpack_public_path__ + "static/media/get-recommendations-tablet-en.d17ecdc3.webp";